import { Navigate, Outlet } from 'react-router-dom';
import { useWebAuth } from '../../../hooks/useWebAuth';

export function AdminRoute() {
  const { user, loading } = useWebAuth();

  if (loading) return null;
  if (!user?.isAdmin) return <Navigate to="/" replace />;

  return <Outlet />;
}
